<template>
    <div class="slider" v-cloak>
        <div class="container_wrap">
            <div class="abgneBlock">
            <ul class="list" ref="slider">
                <!-- <li v-for="(slide, idx) of data" :key="idx" v-if="slide.Link"><a :href="slide.Link.LinkURL" :target="(slide.Link.Blank)? '_blank' : '_self'"><img :src="slide.ImageURL" :alt="slide.Title" /></a></li> -->
                <!-- <li v-for="(slide, idx) of data" :key="idx" v-else><img :src="slide.ImageURL" :alt="slide.Title" /></li> -->
                <li v-for="(slide, idx) of data" :key="idx">
                    <a :href="getLink(slide)" :target="(slide.Link && slide.Link.Blank)? '_blank' : '_self'" @click="checkLink(slide)">
                        <img :src="slide.ImageURL" :alt="slide.Title" />
                    </a>
                </li>
                <!-- <li v-for="(slide, idx) of data" v-if="slide.Link" :key="idx"><a :href="slide.Link.LinkURL" :target="(slide.Link.Blank ? '_blank' : '_self')"><img :src="slide.ImageURL" :alt="slide.Title" /></a></li> -->
            </ul>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus} from './config.js'
import user from './user.js'
import home from './home.js'

export default {
  name: 'Slider',
  props: ["data"],
  data () {
    return {}
  },
  methods: {
    ...user,
    ...home
  },
  computed: {
    bookType: function () {
        let keys = Object.keys(this.$root.bookType)
        this.$root.removeItemFromArray(keys,'index')
        this.$root.removeItemFromArray(keys,'novel')
        return keys
    },
    pageKey: function () {
        let keys = Object.keys(this.$root.bookType)
        let locate
        keys.map(key => {
            if (this.$root.bookType[key].id == this.id) locate = key
        })
        return locate
    }
  },
  mounted () {
    // console.log(`${this.name} mounted`)
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
  }
}
</script>



// WEBPACK FOOTER //
// src/Slider.vue